import React from 'react';
import {Button, Table, Modal} from "antd";
import AddSlotMenu from "./AddSlotMenu";
import moment from 'moment';
import Storage from "../../../services/Storage";
import withAuthorization from "../../../services/Authorization";
import {injectIntl} from "react-intl";
import SAInputNumber from "../../common/input/SAInputNumber";

const Column = Table.Column;
const { confirm } = Modal;

class WeekConfigurationTab extends React.Component {

  showDeleteConfirm = (row, formatMessage) => {
    confirm({
      title: formatMessage({ id: 'section.week-configuration.delete-slot-modal-title'}),
      content: formatMessage({ id: 'section.week-configuration.delete-slot-modal-content'}),
      okText: formatMessage({ id: 'yes'}),
      okType: 'danger',
      cancelText: formatMessage({ id: 'no'}),
      onOk: () => {
        this.deleteRow(row);
      },
    });
  }

  deleteRow = (row) => {
    const {data={}} = this.props;
    data.slots = data.slots || [];
    data.slots = data.slots.filter(e => e !== row);
    this.props.onChange(data);
  };

  onSlotModify = (newRow, oldRow) => {
    const {data={}} = this.props;
    data.slots = data.slots || [];
    data.slots.push(newRow);
    this.props.onChange(data);
    this.deleteRow(oldRow);
  };

  onSlotSave = (value) => {
    const {data={}} = this.props;
    data.slots = data.slots || [];
    data.slots.push(value);
    this.props.onChange(data);
  };

  onMaxTwentyFourSevenArrivalsChange = (value) => {
    const {data={}} = this.props;
    data.maxTwentyFourSevenArrivals = value;
    this.props.onChange(data);
  };

  render() {
    const {intl:{formatMessage}, data={}, hasTwentyFourSeven} = this.props;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';
    const timeFormat = 'HH:mm';

    return (
      <div>
        {hasTwentyFourSeven &&
          <div style={{marginBottom: '1rem'}}>
            <label style={{marginRight: '1rem'}}>{formatMessage({id: 'label.max-247'})}</label>
            <SAInputNumber value={data.maxTwentyFourSevenArrivals || '0'}
                           onChange={this.onMaxTwentyFourSevenArrivalsChange}
                           min={0} defaultValue={0} disabled={!canWrite || Object.keys(data).length < 1}/>
          </div>
        }

        <div>
          <Table dataSource={data.slots}
                 rowKey={((record, lineNumber) => {
                   return record.startTime + lineNumber
                 })} pagination={false}>
            <Column title={formatMessage({id: 'label.startTime'})} dataIndex="startTime"
                    render={(text) => moment(text, timeFormat).format(timeFormat)} defaultSortOrder="ascend"
                    sorter={(a, b) => {return moment(a.startTime, timeFormat).diff(moment(b.startTime, timeFormat), 'minutes')}}
            />
            <Column title={formatMessage({id: 'label.endTime'})} dataIndex="endTime"
                    render={(text) => moment(text, timeFormat).format(timeFormat)}/>
            <Column title={formatMessage({id: 'label.maxTotalArrivals'})}
                    dataIndex="maxTotalArrivals"/>
            <Column title={formatMessage({id: 'label.maxWaitingArrivals'})}
                    dataIndex="maxWaitingArrivals"/>
            <Column title={formatMessage({id: 'label.maxNonWaitingArrivals'})}
                    dataIndex="maxNonWaitingArrivals"/>
            <Column title={formatMessage({id: 'label.maxHomeServiceArrivals'})}
                    dataIndex="maxHomeServiceArrivals"/>
            <Column
              render={(text, row) => (
                canWrite ?
                  <AddSlotMenu data={row} onValidate={(newRow) => this.onSlotModify(newRow, row)} dropdownPosition="right">
                    <a>{formatMessage({id: 'action.edit'})}</a>
                  </AddSlotMenu>
                  : ''
              )}
            />
            <Column
              render={(text, row) => (
                canWrite ? <a onClick={() => this.showDeleteConfirm(row, formatMessage)}>{formatMessage({id: 'action.delete'})}</a> : ''
              )}
            />
          </Table>
        </div>

        {canWrite &&
          <div className="list__footer">
            <AddSlotMenu onValidate={this.onSlotSave}>
              <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                  <use xlinkHref="#icon-plus"/>
                </svg>
                <strong>{formatMessage({id:'add.more'})}</strong>
              </Button>
            </AddSlotMenu>
          </div>
        }
      </div>
    )
  }
}

export default withAuthorization(injectIntl(WeekConfigurationTab), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);

